import React from 'react'
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <polygon points="19.2,22.5 17.6,24 4.8,12 17.6,0 19.2,1.5 7.9,12 		" />
  </React.Fragment>,
  'LeftIcon'
)
